<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل مدينة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/citiesview">المدن</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل مدينة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-if="!loader" class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-pencil-square mx-2 text-brown"></i> عرض البيانات
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="cityError" :alertMessage= "message" />
              </div>
              <div v-if="successfuly" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <label class="form-label" for="">المنطقة:</label>
                    <div>{{ (regionObj)? regionObj.name : 'لم يحدد' }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col-12 col-sm-6">
                    <label class="form-label" for="">الاسم - عربي:</label>
                    <div>{{ cityName }}</div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <label class="form-label" for="">الاسم - انجليزي:</label>
                    <div>{{ nameEn }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">خط العرض (latitude):</label>
                    <div>{{ latitude }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">خط الطول (longitude):</label>
                    <div>{{ longitude }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">الحاله:</label>
                    <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name:'CitiesRead',
  data(){
    return {
      city_id: this.$route.params.id,
      loader: false,
      cityError: false,
      message: '',
      cityName: "",
      nameEn: "",
      longitude: "",
      latitude: "",
      isLoading: false,
      status: null,
      successfuly: false,
      rows: [],
      region_id: null,
      regionObj: null,
    }
  },
  methods:{
    region_get_Data() {
      this.loader = true;
      this.$http.get(`/api/admin/cities/retrieve/${this.city_id}`).then(res => {
        this.loader = false;
        this.cityName = res.data.city.name;
        this.nameEn = res.data.city.nameEn;
        this.latitude = res.data.city.latitude;
        this.longitude = res.data.city.longitude;
        this.status = res.data.city.isActive;
        this.region_id = res.data.city.regionId;
        this.rows = res.data.regions;
        this.regionObj = res.data.city.Region;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.cityError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.region_get_Data();
  }
}
</script>